import { useState, type FormEvent } from "react";

import { RaqozLogo } from "@/components/brand/raqoz-logo";
import { FieldError } from "@/components/field-error";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { supabase } from "@/lib/supabase";

export function AuthScreen({ onAuthenticated }: { onAuthenticated: () => void }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  async function signIn(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError("");
    const { error: authError } = await supabase.auth.signInWithPassword({
      email,
      password,
    });
    setBusy(false);
    if (authError) setError(authError.message);
    else onAuthenticated();
  }
  return (
    <main className="grid min-h-screen bg-white lg:grid-cols-[1.1fr_.9fr]">
      <section className="hidden flex-col justify-center overflow-hidden bg-gradient-to-br from-[#102f28] to-[#1a5245] p-[8vw] text-white lg:flex">
        <RaqozLogo inverse />
        <p className="mt-16 text-xs font-bold tracking-[.14em] text-emerald-200">
          CONTROLLED PROCUREMENT WORKSPACE
        </p>
        <h1 className="mt-3 max-w-3xl font-serif text-6xl leading-[1.02] tracking-tight">
          Every purchase.
          <br />
          One accountable path.
        </h1>
        <p className="mt-6 max-w-xl text-lg leading-8 text-emerald-100/80">
          Requisition to receipt, with commercial clarity and an audit trail by
          design.
        </p>
      </section>
      <section className="grid place-items-center p-8">
        <form onSubmit={signIn} className="grid w-full max-w-md gap-5">
          <div>
            <p className="eyebrow">SECURE SUPABASE WORKSPACE</p>
            <h2 className="mt-2 font-serif text-4xl">Welcome back</h2>
            <p className="mt-2 text-sm text-slate-500">
              Use the credentials assigned to your organisation.
            </p>
          </div>
          <Label>
            Email address
            <Input
              type="email"
              autoComplete="username"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
            />
          </Label>
          <Label>
            Password
            <Input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
            />
          </Label>
          <Button disabled={busy} type="submit" className="w-full">
            {busy ? "Signing in…" : "Sign in securely"}
          </Button>
          <FieldError>{error}</FieldError>
          <small className="text-slate-500">
            RAQOZ · Cyclotron Technologies
          </small>
        </form>
      </section>
    </main>
  );
}
